export default __webpack_public_path__ + "static/media/banner.f968a48a.png";